module.exports = __webpack_public_path__ + "static/media/group-mobile.9744373c.svg";